import { Flex } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import CustomReactSelect from "../../../general/form/CustomReactSelect";

const OnboardingStep12 = ({ formData, handleChange }) => {


  return (
    
<>   
    

      <Flex direction="column" gap={8}>
        <h6>Legal structure</h6>
        <Flex direction="column">
          <Fieldset
            label="Vehicle Type"
            description="Select the type of legal structure used for the fund."
            flex={1}
            input={
              <CustomReactSelect
  name="vehicleType"
  placeholder="Choose vehicle type"
  options={[
    { value: "RAIF", label: "RAIF" },
    { value: "SIF", label: "SIF" },
    { value: "SICAR", label: "SICAR" },
    { value: "SCS", label: "SCS" },
    { value: "SCSp", label: "SCSp" },
    { value: "SA", label: "SA" },
    { value: "SARL", label: "SARL" },
  ]}
  value={{
    value: formData.vehicleType,
    label: formData.vehicleType,
  }}
  onChange={(selectedOption) =>
    handleChange({
      target: {
        name: "vehicleType",
        value: selectedOption ? selectedOption.value : "",
      },
    })
  }
/>

            }
          />

          <Fieldset
            label="Structure Type"
            description="Specify if the fund operates as standalone or as part of an umbrella structure."
            flex={1}
            input={
              <CustomReactSelect
                name="structureType"
                placeholder="Choose structure type"
                options={[
                  { value: "Standalone", label: "Standalone" },
                  {
                    value: "Umbrella with compartments",
                    label: "Umbrella with compartments",
                  },
                  {
                    value: "Umbrella with planned compartments",
                    label: "Umbrella with planned compartments",
                  },
                ]}
                value={{
                  value: formData.structureType,
                  label: formData.structureType,
                }}
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "structureType",
                      value: selectedOption ? selectedOption.value : "",
                    },
                  })
                }
              />
            }
          />

          <Fieldset
            label="Master-Feeder Position"
            description="Indicate the position of the fund within a master-feeder setup, if applicable."
            flex={1}
            input={
              <CustomReactSelect
                name="masterFeederPosition"
                placeholder="Choose master-feeder position"
                options={[
                  { value: "Standalone", label: "Standalone" },
                  { value: "Master", label: "Master" },
                  {
                    value: "Feeder",
                    label: "Feeder (+ master identification)",
                  },
                ]}
                value={{
                  value: formData.masterFeederPosition,
                  label: formData.masterFeederPosition,
                }}
                onChange={(selectedOption) =>
                  handleChange({
                    target: {
                      name: "masterFeederPosition",
                      value: selectedOption ? selectedOption.value : "",
                    },
                  })
                }
                
              />
            }
          />
        </Flex>
      </Flex>

      
</>
  );
};

export default OnboardingStep12;
